import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';

class OfferService extends BaseService {
    constructor() {
        super(apiroutes.OFFER);
    }

    async create(data) {
        const contentType = data instanceof FormData ? 'multipart' : 'json';
        return await super.customCall('POST', '', data, null, contentType);
    }

    async update(id, data) {
        const contentType = data instanceof FormData ? 'multipart' : 'json';
        return await super.customCall('PATCH', `/${id}`, data, null, contentType);
    }

    async updateStatus(id, data) {
        return await super.customCall('PUT', `/status/${id}`, data, null, 'json');
    }

    async delete(id) {
        return await super.delete(id);
    }

    async getAll(params = {}) {
        return await super.customCall('GET', '', null, params, null);
    }

    async getById(id) {
        return await super.getById(id);
    }

    async search(searchTerm, filters = {}) {
        return await super.search(searchTerm, filters);
    }

    async getByCompanyId(companyId) {
        return await super.customCall('GET', ``, null, { companyId: companyId }, null);
    }

    async getOfferDetailById(id, companyId) {
        return await super.customCall('GET', `/${id}`, null, { companyId: companyId }, null);
    }
}
const OfferServices = new OfferService();
export default OfferServices;